import app_img from '@/public/article/App.webp';
import time_img from '@/public/article/Orders.webp';
import article1 from '@/public/article/picture.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import invoicing from '@/public/industries/fire_safety/Customizable Forms for Efficient Record-keeping.webp';
import main_bg from '@/public/industries/fire_safety/main.webp';
import managment_img from '@/public/industries/painting/Proactive Notifications.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'Does My Fire Safety Business Need Software?',
    text: 'Fire safety software makes your operation flow smoother, ensures you are in compliance, and enhances your total safety protocols. It helps you run tasks in a streamlined manner, keeping you in compliance with the top safety standards in your business. Proper software investment should change your fire safety management approach.',
  },
  {
    title: 'Is Orcatec Free Fire Safety Software?',
    text: `Orcatec has a free starter pack that will give you access to the key features without paying anything. You may upgrade and choose paid functionalities as your business needs grow. This way, you get to trial the software and its benefits with respect to your specific needs before you commit to anything.`,
  },
  {
    title: 'Does Orcatec Have an App for Fire Safety Companies?',
    text: `Yes, there is this very flexible app by Orcatec that works on most platforms: iOS and Android. The app allows fire safety professionals to manage jobs and access vital information from any place to increase their responsiveness and efficiency at work. In a user-friendly manner, real-time updating is allowed for maximum effect in the field.`,
  },
  {
    title: 'Does My Fire Safety Business Need Software?',
    text: 'Fire safety software makes your operation flow smoother, ensures you are in compliance, and enhances your total safety protocols. It helps you run tasks in a streamlined manner, keeping you in compliance with the top safety standards in your business. Proper software investment should change your fire safety management approach.',
  },
  {
    title: 'Is Orcatec Free Fire Safety Software?',
    text: `Orcatec has a free starter pack that will give you access to the key features without paying anything. You may upgrade and choose paid functionalities as your business needs grow. This way, you get to trial the software and its benefits with respect to your specific needs before you commit to anything.`,
  },
  {
    title: 'Does Orcatec Have an App for Fire Safety Companies?',
    text: `Yes, there is this very flexible app by Orcatec that works on most platforms: iOS and Android. The app allows fire safety professionals to manage jobs and access vital information from any place to increase their responsiveness and efficiency at work. In a user-friendly manner, real-time updating is allowed for maximum effect in the field.`,
  },
];

const testimonals = [
  {
    text: `Orcatec's software has revolutionized how we handle fire safety. It's incredibly user-friendly and adaptable to our specific needs. Our team can access all the necessary tools on any device, making our jobs so much easier!`,
    name: 'Sarah Lee, ',
    position: 'Operations Director',
  },

  {
    text: `I was skeptical about switching, but the free starter package was a game-changer. The ability to choose and pay for only the features we use has significantly cut our costs. Highly recommend it!`,
    name: 'Mike Brown, ',
    position: 'Compliance Officer',
  },
  {
    text: `Thanks to Orcatec, our compliance issues are a thing of the past. The customizable features have allowed us to perfect our protocols and keep everything running smoothly. Their support team is also top-notch.`,
    name: 'John Doe, ',
    position: 'Safety Manager',
  },

  {
    text: `Orcatec's software has revolutionized how we handle fire safety. It's incredibly user-friendly and adaptable to our specific needs. Our team can access all the necessary tools on any device, making our jobs so much easier!`,
    name: 'Sarah Lee, ',
    position: 'Operations Director',
  },

  {
    text: `I was skeptical about switching, but the free starter package was a game-changer. The ability to choose and pay for only the features we use has significantly cut our costs. Highly recommend it!`,
    name: 'Mike Brown, ',
    position: 'Compliance Officer',
  },
  {
    text: `Thanks to Orcatec, our compliance issues are a thing of the past. The customizable features have allowed us to perfect our protocols and keep everything running smoothly. Their support team is also top-notch.`,
    name: 'John Doe, ',
    position: 'Safety Manager',
  },
];

const industries = {
  title: 'Our Top Industries',
  description: `Our industries section provides an in-depth look at how different businesses, from residential to commercial painting contractors, can leverage our painting company software for optimal efficiency. Discover each industry's unique challenges and solutions, ensuring your painting business thrives regardless of the segment.
  `,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Fire Safety Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Streamlined Work Order Management',
      },
      href: '#',
      tag: 'Work Order Management',
      title: 'Streamlined Dispatching & Scheduling',
      text: `Optimize your fire safety operations with efficient scheduling tools that ensure no inspection or maintenance job falls through the cracks. Our software’s robust scheduling system allows you to manage and assign tasks effectively.`,
      list: [
        {
          text: 'Easily schedule routine inspections and set repeated jobs for a set period. This ensures regular compliance without manual reentry.',
        },
        {
          text: 'Assign jobs to the appropriate technician based on availability and expertise, streamlining operations and enhancing service quality.',
        },
        {
          text: 'Utilize advanced dispatch features to keep your team informed and ready, improving response times and operational efficiency.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer Relationships Management',
      },
      href: '#',
      tag: ' Notifications System',
      title: 'Enhanced Automated Notifications',
      text: `Keep your clients in the loop with automated notifications. Our system ensures that all parties are timely informed about upcoming inspections and maintenance activities.`,
      list: [
        {
          text: 'Automatically send notifications to clients about their upcoming inspections, reducing no-shows and ensuring preparations.',
        },
        {
          text: 'Tailor notification texts to meet specific client needs and enhance communication clarity.',
        },
        {
          text: 'Personalize messages based on client preferences and history for a more targeted approach.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: time_img,
        alt: ' Job Management',
      },
      href: '#',
      tag: 'Job Management',
      title: 'Comprehensive Customer & Equipment Tracking',
      text: `Maintain a detailed database of all customer interactions, their fire safety equipment, and service history. This centralized information hub enhances service delivery and customer satisfaction.`,

      list: [
        {
          text: 'Keep track of customer interactions, including notes, past communications, and specific needs or preferences.',
        },
        {
          text: 'Manage detailed records of each customer’s fire safety equipment, including maintenance history and upcoming inspection dates.',
        },
        {
          text: 'Access and manage historical data on previous work, making it easier to provide consistent and informed service.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Customizable Forms',
      },
      href: '#',
      tag: 'Customizable Forms',
      title: 'Customizable Forms for Efficient Record-keeping',
      text: `Create and utilize custom forms tailored to your business needs, from inspection checklists to incident reports. This feature supports compliance and enhances operational accuracy.`,
      list: [
        {
          text: 'Develop and deploy customized checklists that standardize inspection processes and ensure thorough assessments.',
        },
        {
          text: 'Create logs for regular maintenance activities, ensuring all details are recorded and accessible.',
        },
        {
          text: 'Quickly generate detailed incident reports to document any occurrences, facilitating easier resolution and documentation for compliance purposes.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Fire Safety Business Software',
  title: {
    first_part: 'Enhance Your Safety with Our',
    second_part: ' Free Fire Safety Software!',
  },
  description: `Unlock unparalleled protection with our cutting-edge Free Fire Safety Software, designed specifically for businesses looking to fortify their fire management strategies. Our software offers seamless integration, real-time alerts, and comprehensive management tools, setting a new standard in fire safety efficiency and reliability.`,
  info: [
    { title: '40%', description: 'Reduction in Reported Fire Incidents' },
    {
      title: '50%',
      description: 'Faster Emergency Response Time',
    },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What is Fire Safety Business Software?',
  },
  title: 'What is Fire Safety Business Software?',
  description: `Fire safety business software is a niche piece of software, basically designed to help in the managing and streamlining of all the elements within an organization in regard to fire safety and compliance. This is going to be a software business imperative for businesses looking to hold a stringent guideline in safety assurance and ensure the same is in harmony with the local and national fire regulations. `,
  item: [
    {
      title: 'Incident Management in Real Time',
      description: `The solution helps you track and manage fire incidents in real time. It will guide the in-house response team with predefined protocols. Additionally, the system facilitates quick responses by your team to incidents or emergencies through efficient dispatching, internal communication, and app notifications. `,
    },
    {
      title: 'Equipment and Asset Management.',
      description:
        ' In-built with features for the management of fire safety equipment like extinguishers, alarms, and sprinkler systems, Orcatec software ensures all safety devices are maintained, functional, and inspected at regular intervals.',
    },
    {
      title: 'Training and Drills Coordination',
      description: ` This software helps plan, track, and document every training session and safety drill.`,
    },
    {
      title: 'Compliance and Reporting Capabilities',
      description:
        'Logs all compliance-related activities, enabling easy audit by businesses about their adherence to regulations. ',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why are Fire Safety Contractors Choosing Orcatec?',
  },
  title: 'Why are Fire Safety Contractors Choosing Orcatec?',
  description: `Fire safety contractors are increasingly choosing Orcatec for their operational needs due to several compelling reasons that align closely with the demands of their industry:`,
  item: [
    {
      title: '',
      description:
        'Orcatec offers a no-cost introductory package that allows fire safety contractors to experience the software without initial investment.  ',
    },
    {
      title: '',
      description:
        'Orcatec acknowledges that every business is different and comes with unique requirements and budgets. ',
    },
    {
      title: '',
      description: `The software has been created with a pay-as-you-use model in mind, allowing users to choose only the functionality they require and pay for only those features.  `,
    },
    {
      title: '',
      description: `Be it changing the dashboard layout, setting up flows from scratch, or creating your form, fire safety contractors can tweak the application as per their processes and needs.  `,
    },

    {
      title: '',
      description: `There is support for computers, tablets, and smartphones, with the software designed for both iOS and Android users. Offering extensive support and integration, it seamlessly connects with my existing system, with ongoing support to ensure I get the most from the software.
      `,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Get the latest insights; browse the most relevant in the industry on our blog. Stay updated with expert analysis and tips to better steer through the changing landscape of fire safety. You can find updates on fire safety regulations and innovative fire safety strategies on our blog.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Orcatec offers services to a wide variety of industries, all with distinct fire safety needs. These include manufacturing plants, office buildings, retail environments, and educational facilities, with fire protection services that are tailored to meet their compliance needs and make the environments safe. Find out how our specialist software can be configured to meet the needs of your industry today.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
